import React, { useEffect, useRef } from 'react';
import Form from 'js/components/common/Form';
import { Checkbox } from 'js/components/common/Fields/Checkbox';

import style from './MultiSelectForm.scss';

export const MultiSelectForm = ({ options = [], selected = [], onChange, onClose, classNames, onKeyDown }) => {
    const multiSelectRef = useRef();
    const handleChange = (id) => {
        const nextSelected = selected.includes(id)
            ? selected.filter(item => item !== id)
            : [...selected, id];

        onChange(nextSelected);
    };

    useEffect(() => {
        const handleBlur = e => !multiSelectRef.current.contains(e.target) && onClose();
        addEventListener('click', handleBlur);
        return () => removeEventListener('click', handleBlur);
    }, [multiSelectRef, onClose]);

    return (
        <Form
            onSubmit={() => {}}
            render={() => (
                <ul
                    ref={multiSelectRef}
                    className={style.list}
                >
                    {options.map(({ id, label, hint }) => (
                        <li
                            key={id}
                            className={style.option}
                            onKeyDown={onKeyDown}
                        >
                            <Checkbox
                                name={`checkbox_${id}`}
                                label={label}
                                hint={hint}
                                aria-label={label}
                                checked={selected.includes(id)}
                                onChange={() => handleChange(id)}
                                classNames={classNames}
                            />
                        </li>
                    ))}
                </ul>
            )}
        />
    );
};
